


















import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            selection: null,
            ignoreSelectionChanges: false,
        };
    },
    computed: {
        availableSet() {
            return [
                {
                    text: this.$t("common.all"),
                    value: -1,
                },
                {
                    text: this.$t("common.enabled"),
                    value: 1,
                },
                {
                    text: this.$t("common.disabled"),
                    value: 0,
                },
            ];
        },
    },
    watch: {
        selection(newValue) {
            if (newValue && newValue.value != null) {
                if (!this.ignoreSelectionChanges) this.$emit("input", newValue.value);
                this.ignoreSelectionChanges = false;
            } else {
                this.selection = {
                    text: this.$t("common.all"),
                    value: -1,
                };
            }
        },
    },
    mounted() {
        this.ignoreSelectionChanges = true;
        this.selection = {
            text: this.$t("common.all"),
            value: -1,
        };
    },
});
